import { polaritiesOf } from '@voll-intelligence/domain';
import type { ChatUiFlightOffer, FlightTariffView } from '@voll-intelligence/genui-contract';
import {
  OfferListBody as KitOfferListBody,
  useOfferFares as useKitOfferFares,
  type OfferFares as KitOfferFares,
  type OfferListBodyProps,
} from '@voll-intelligence/intelligence-ui-kit';
import { useFlightTariff, useOfferListEnv } from './flight_results_env.js';
import { BLOCK_ELEVATION } from '../../shared/ui/block_elevation.js';

/** A escada de tarifas de uma lista de ofertas do chat. */
export type OfferFares = KitOfferFares<ChatUiFlightOffer, FlightTariffView>;

/**
 * O estado da escada do kit (#4997) com a porta de tarifas do `GenUiConfig` e o
 * classificador do domain. Os dois cards do chat montam este.
 */
export function useOfferFares(
  offers: readonly ChatUiFlightOffer[],
  options: {
    enabled: boolean;
    autoExpandId?: string | null;
    seedFare?: { offerId: string; fareId: string } | null;
  },
): OfferFares {
  const tariff = useFlightTariff();
  return useKitOfferFares(offers, { ...options, tariff, classify: polaritiesOf });
}

/** A lista de ofertas do kit (#4997) ligada ao catálogo, ao cadastro, à
 *  telemetria e ao drawer de detalhe do genui-kit. Os dois cards do chat a montam,
 *  então cada oferta veste a elevação do bloco da thread (#6296); `contents` não
 *  entra no layout. */
export function OfferListBody(
  props: Omit<OfferListBodyProps<ChatUiFlightOffer, FlightTariffView>, 'env'>,
) {
  const env = useOfferListEnv();
  return (
    <div className={`contents ${BLOCK_ELEVATION}`}>
      <KitOfferListBody {...props} env={env} />
    </div>
  );
}
